import type { ButtonProps } from "antd";
import { Button } from "antd";

interface NFTNameProps extends ButtonProps {
  refToUse?: React.RefObject<HTMLButtonElement>;
  canUseRef?: boolean;
}

export const NFTNameLink: React.FC<NFTNameProps> = ({ refToUse, canUseRef, ...props }) => {
  return (
    <Button ref={canUseRef ? refToUse : null} {...props}>
      {props.children}
    </Button>
  );
};
